var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},[_c('avatar-header',{attrs:{"avatar":_vm.share && _vm.share.coach.avatar,"title":("绑定您的私人教练：" + (_vm.share && _vm.share.coach.name))}}),_vm._v(" "),_c(_vm.currentStep.component,_vm._b({tag:"component",on:{"next":function($event){_vm.nextStep(_vm.currentStep.next)}}},'component',_vm.currentStep.props || {},false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-023451db","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/share/Share.vue
// module id = null
// module chunks = 